import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { RatingModalCard } from "@/components/RatingModal";

export const OrderRateButton = ({ orderId, pendingList }) => {
  const [pending, setPending] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (pendingList) { setPending(pendingList.find((p) => p.order_id === orderId) || null); return; }
    api.get("/ratings/pending")
      .then((r) => setPending((r.data || []).find((p) => p.order_id === orderId) || null))
      .catch(() => setPending(null));
  }, [orderId, pendingList]);
  if (!pending) return null;
  return (
    <div className="bg-sky-500/10 border border-sky-500/40 rounded-md p-4 flex flex-wrap items-center gap-3" data-testid="order-rate-box">
      <div className="flex-1 min-w-[200px] text-sm text-neutral-200">
        Aún no calificas {pending.role === "buyer" ? "al vendedor" : "al comprador"} <b className="text-white">{pending.other_name}</b>.
        <span className="block text-xs text-neutral-400 mt-0.5">Tu nota solo se muestra cuando ambos califican.</span>
      </div>
      <button onClick={() => setOpen(true)} data-testid="order-rate-btn"
        className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-[#EF4444] hover:bg-[#DC2626] text-white text-sm font-semibold transition-colors">
        <Star size={14} /> Calificar
      </button>
      {open && <RatingModalCard pending={pending} onDismiss={() => setOpen(false)} onSubmitted={() => { setOpen(false); setPending(null); }} />}
    </div>
  );
};
